<template>
    <outboxCon bg="#F8F9FC">
        <div class="operate-solution">
            <img class="solution-bg" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-solution-bg.png">
            <app-title class="z-1" main='我们提供全套运营解决方案' sub='针对机构招生+续费提升的难题'></app-title>
            <div class="solution-tab">
                <p class="item">招生提升</p>
                <p class="item">续费提升</p>
            </div>
            <div class="solution-content">
                <div class="solution-content-item" :class="{'large': index === 2}" v-for="(item, index) in solutionList" :key="`sc${index}`">
                    <p class="sc-index">{{item.index}}</p>
                    <p class="sc-name">{{item.name}}</p>
                    <div class="child-info">
                      <div class="popover-item" v-for="(child, childIndex) in item.children" :key="`cii${childIndex}`">
                        <div class="hover-info home-pover" v-if="child.id === currentId" :class="`home-pover${index + 1}`" >
                            <div class="hover-info-box">
                                <p class="hib-title">{{child.name}}</p>
                                <p class="hib-des">{{child.des}}</p>
                            </div>
                            <img class="hover-img" v-for="(img, imgIndex) in child.imgs" :class="{ isPortrait: child.isPortrait }" :key="`solutionImg${imgIndex}`" :src="`${img}?x-oss-process=image/resize,m_fixed,h_${child.isPortrait ? 200 : 150},w_${child.isPortrait ? 150 : 200}`">
                        </div>
                        <p class="child-info-item" :class="{active: child.id === currentId}" @mouseover="enterSelect(child.id)" @mouseout="outSelect"><span class="out-box"><span class="inner-box"></span></span>{{child.name}}</p>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </outboxCon>
</template>
<script>
import { solutionList } from '@/const/index'
export default {
  data () {
    return {
      solutionList: solutionList,
      placeList: ['bottom-start', 'bottom-start', 'bottom-end', 'bottom-end'],
      currentId: 2,
      timer: null
    }
  },
  mounted () {
    this.selectRandom()
  },
  methods: {
    enterSelect (id) {
      clearInterval(this.timer)
      this.currentId = id
    },
    outSelect () {
      this.selectRandom()
    },
    selectRandom () {
      let _this = this
      this.timer = setInterval(() => {
        let random = Math.ceil(Math.random() * 11)
        _this.currentId = random
      }, 3000)
    }
  }
}
</script>
<style lang="scss" scoped>
    .operate-solution{
        width: $main-width;
        margin: 0 auto;
        padding: 100px 66px 187px;
        background: #F8F9FC;
        position: relative;
        .z-1{
            position: relative;
            z-index: 1;
        }
        .solution-bg{
            width: 1279;
            height: 605px;
            position: absolute;
            top: 104px;
            left: 0px;
            z-index: 0;
        }
        .solution-tab{
            width: 1060px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 205px;
            position: relative;
            z-index: 1;
            .item{
                width: 50%;
                font-size:25px;
                font-family:PingFangSC-Regular;
                font-weight:bold;
                font-style:italic;
                line-height:50px;
                text-align: center;
            }
        }
        .solution-content{
            margin-top: 94px;
            width: 1260px;
            padding-left: 62px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            position: relative;
            z-index: 1;
            .solution-content-item{
                width: 260px;
                text-align: left;
                .sc-index{
                    font-size:23px;
                    font-family:PingFang SC;
                    font-weight:bold;
                    font-style:italic;
                    color:#0085FF;
                    line-height: 17px;
                }
                .sc-name{
                    font-size:22px;
                    font-family:PingFang SC;
                    font-weight:600;
                    margin-top: 16px;
                    position: relative;
                    &::after{
                        content: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-arrow.png');
                        width: 123px;
                        height: 15px;
                        display: inline-block;
                        margin-left: 20px;
                    }
                }
                &.large{
                    width: 310px;
                }
                &:last-of-type{
                    .sc-name::after{
                        display: none;
                    }
                }
                .child-info{
                  margin-top: 55px;
                  position: relative;
                  .pover{
                    position: relative;
                    left: -90px;
                  }
                  .popover-item{
                    position: relative;
                    .home-pover{
                      padding: 0px;
                    }
                    .hover-info{
                      position: absolute;
                      top: 30px;
                      left: 0px;
                      padding: 13px;
                      background:#ffffff;
                      border:1px solid rgba(0,133,255,0.6);
                      box-shadow:5px 9px 16px 0px rgba(56,74,93,0.07);
                      border-radius:5px;
                      display: flex;
                      justify-content: flex-start;
                      align-items: flex-start;
                      z-index: 10;
                      .hover-info-box{
                        width: 135px;
                        .hib-title{
                          font-family: PingFangSC-Semibold;
                          font-size:16px;
                          line-height: 20px;
                          margin-top: 15px;
                        }
                        .hib-des{
                          font-family: PingFangSC-Regular;
                          font-size: 14px;
                          line-height: 24px;
                          margin-top: 5px;
                        }
                      }
                      .hover-img{
                        width: 200px;
                        height: 150px;
                        margin-left: 10px;
                        &.isPortrait{
                          width: 150px;
                          height: 200px;
                        }
                      }
                    }
                    .home-pover1{
                      transform: translateX(120px);
                    }
                    .home-pover2{
                      transform: translateX(100px);
                    }
                    .home-pover3{
                      transform: translateX(-100%);
                      left: 10px;
                    }
                    .home-pover4{
                      left: 10px;
                      transform: translateX(-100%);
                    }
                  }
                  .child-info-item{
                      font-size:16px;
                      font-family:PingFang SC;
                      font-weight:600;
                      margin-bottom: 53px;
                      display: flex;
                      justify-content: flex-start;
                      align-items: center;
                      outline: none;
                      .out-box{
                          width: 16px;
                          height: 16px;
                          border-radius: 50%;
                          overflow: hidden;
                          position: relative;
                          background: #ffffff;
                          display: inline-block;
                          margin-right: 9px;
                          transition: background 1s;
                          .inner-box{
                            width: 7px;
                            height: 7px;
                            border-radius: 50%;
                            background: #515151;
                            overflow: hidden;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            transition: background 1s;
                          }
                      }
                      // &:hover{
                      //     .out-box{
                      //         background: rgba(0,133,255,0.2);
                      //         .inner-box{
                      //             background: #0085FF;
                      //         }
                      //     }
                      // }
                      &.active {
                        .out-box{
                              background: rgba(0,133,255,0.2);
                              .inner-box{
                                  background: #0085FF;
                              }
                          }
                      }
                  }
                  &:last-of-type{
                    margin-bottom: 0px;
                  }
                }
            }
        }
    }
</style>
<style lang="scss">
// 首页弹框位移
  // .home-pover{
  //   padding: 0px;
  // }
  // .home-pover1{
  //   transform: translateX(8px);
  // }
  // .home-pover2{
  //   transform: translateX(8px);
  // }
  // .home-pover3{
  //   transform: translateX(-300px);
  // }
  // .home-pover4{
  //   transform: translateX(-250px);
  // }
  // .hover-info{
  //   padding: 13px;
  //   background:#ffffff;
  //   border:1px solid rgba(0,133,255,0.6);
  //   box-shadow:5px 9px 16px 0px rgba(56,74,93,0.07);
  //   border-radius:5px;
  //   display: flex;
  //   justify-content: flex-start;
  //   align-items: flex-start;
  //   .hover-info-box{
  //     width: 135px;
  //     .hib-title{
  //       font-family: PingFangSC-Semibold;
  //       font-size:16px;
  //       line-height: 20px;
  //       margin-top: 15px;
  //     }
  //     .hib-des{
  //       font-family: PingFangSC-Regular;
  //       font-size: 14px;
  //       line-height: 24px;
  //       margin-top: 5px;
  //     }
  //   }
  //   .hover-img{
  //     width: 200px;
  //     height: 150px;
  //     margin-left: 10px;
  //     &.isPortrait{
  //       width: 150px;
  //       height: 200px;
  //     }
  //   }
  //   &.isPortrait{
  //     .hover-img{
  //       width: 150px;
  //       height: 200px;
  //     }
  //   }
  // }
</style>
